import axios from 'axios';
import { getAuthenticationConfig, getPacsEndpoints } from './getConfig';
import { getHeadersConfig } from './getHeadersConfig';
import { getAuthHeader } from './authHeaderConfig';

export const downloadStudy = async ({ studyInstanceUID, includeDicomdir, config, onDownloadProgress }) => {
  if (!studyInstanceUID) return;

  const { wadoRsEndpoint } = getPacsEndpoints(config);
  if (!wadoRsEndpoint) return;

  const { oidcEnabled } = getAuthenticationConfig(config);
  const authorizationHeader = oidcEnabled ? config.authorizationHeader : getAuthHeader(config);
  const query = includeDicomdir ? 'accept=application/zip&dicomdir=true' : 'accept=application/zip';
  const url = `${wadoRsEndpoint}/studies/${encodeURIComponent(studyInstanceUID)}?${query}`;
  const response = await axios.get(url, {
    ...getHeadersConfig(authorizationHeader),
    responseType: 'blob',
    onDownloadProgress,
  });

  const blobUrl = window.URL.createObjectURL(response.data);
  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = `study-${studyInstanceUID}.zip`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(blobUrl);
};
